import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RUDetailedLocationService } from '../ru-detailed-location.service';
import { RUDetailedLocation } from '../ru-detailed-location';
import { RUDetailedLocationComponent } from '../ru-detailed-location/ru-detailed-location.component';
import { PictureService } from '@app/_components/picture/picture.service';

@Component({
    selector: 'app-ru-detailed-location-list',
    templateUrl: './ru-detailed-location-list.component.html',
    styleUrls: ['./ru-detailed-location-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RUDetailedLocationListComponent implements OnInit {
	constructor(
		private pictureService: PictureService,
		private rUDetailedLocationService: RUDetailedLocationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = rUDetailedLocationService.statuses
	}



	// data
	rUDetailedLocations: any;
	rUDetailedLocation: RUDetailedLocation;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'rUDetailedLocationId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'locationId', header: 'Location ID', width: 'auto' },
		{ field: 'locationTypeId', header: 'Location Type ID', width: 'auto' },
		{ field: 'parentLocationId', header: 'Parent Location ID', width: 'auto' },
		{ field: 'timeZone', header: 'timeZone', width: 'auto' },
	];
	
	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rUDetailedLocationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-rUDetailedLocation-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.rUDetailedLocationService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.rUDetailedLocations = res.data.rUDetailedLocations;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.rUDetailedLocations = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(rUDetailedLocation: RUDetailedLocation) {
		try {
			this.formLoading = true;
			this.rUDetailedLocationService.update(rUDetailedLocation)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.rUDetailedLocations.map((rUDetailedLocation, i) => {
							if (rUDetailedLocation.rUDetailedLocationId === res.data.rUDetailedLocation.rUDetailedLocationId) {
								this.rUDetailedLocations[i] = res.data.rUDetailedLocation;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(rUDetailedLocation: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(rUDetailedLocation));

			this.formLoading = true;
			this.rUDetailedLocationService.delete(rUDetailedLocation.rUDetailedLocationId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.rUDetailedLocations.splice(this.rUDetailedLocations.indexOf(rUDetailedLocation), 1);
						this.recordTotal = this.rUDetailedLocations.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RUDetailedLocation ' + rUDetailedLocation.rUDetailedLocationId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RUDetailedLocation ' + rUDetailedLocation.rUDetailedLocationId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RU Detailed Location'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RUDetailedLocationComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRUDetailedLocationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(rUDetailedLocation: RUDetailedLocation) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			rUDetailedLocation: rUDetailedLocation,
			title: 'Edit RU Detailed Location'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RUDetailedLocationComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRUDetailedLocationCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRUDetailedLocationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRUDetailedLocationCB(rUDetailedLocation: RUDetailedLocation) {
		console.log('Adding RUDetailedLocation: ' + JSON.stringify(rUDetailedLocation));
		// if we don't have a rUDetailedLocations array yet...
		if (!this.rUDetailedLocations) {
			this.rUDetailedLocations = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.rUDetailedLocations.unshift(rUDetailedLocation);

		// no idea what this is but it is required to update the array
		this.rUDetailedLocations = [...this.rUDetailedLocations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUDetailedLocation ' + rUDetailedLocation.rUDetailedLocationId + ' Added', life: 3000 });
	}

	updateRUDetailedLocationCB(rUDetailedLocation: RUDetailedLocation) {
		console.log('Updating RUDetailedLocation: ' + JSON.stringify(rUDetailedLocation));
		let itemIndex = this.rUDetailedLocations.findIndex((item: any) => item.rUDetailedLocationId === rUDetailedLocation.rUDetailedLocationId);
		this.rUDetailedLocations[itemIndex] = rUDetailedLocation;

		// no idea what this is but it is required to update the array
		this.rUDetailedLocations = [...this.rUDetailedLocations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUDetailedLocation ' + rUDetailedLocation.rUDetailedLocationId + ' Updated', life: 3000 });
	}

	deleteRUDetailedLocationCB(rUDetailedLocation: RUDetailedLocation) {
		console.log('Removing RUDetailedLocation: ' + rUDetailedLocation);
		this.rUDetailedLocations.splice(this.rUDetailedLocations.indexOf(rUDetailedLocation), 1);
		this.recordTotal = this.rUDetailedLocations.length;

		// no idea what this is but it is required to update the array
		this.rUDetailedLocations = [...this.rUDetailedLocations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RUDetailedLocation ' + rUDetailedLocation.rUDetailedLocationId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.rUDetailedLocations ? this.first === (this.rUDetailedLocations.length - this.rows) : true; }
	isFirstPage(): boolean { return this.rUDetailedLocations ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(rUDetailedLocation: any) {
		if (rUDetailedLocation?.status) {
			const status = this.statuses.find((e: any) => e.value == rUDetailedLocation.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	getLocations(){
		this.formLoading = true;
		try {
			this.pictureService.getLocations()
				.subscribe(
					res => {
						console.log('Update picture sort order: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Location Saved Successfully." });
						this.loadLazy(this.lazyLoadEvent);
					},
					err => {
						this.formLoading = false;
						console.log('Update picture sort order FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false;});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}
}
